<span class="d-flex align-items-center" [formlyAttributes]="field">
  <span class="template-label">{{ field.templateOptions.label }}</span>
  <i
    *ngFor="let item of directions"
    (click)="select(item)"
    [class.isSelected]="isSelected(item)"
    class="icon-align icon-align-{{ item }}"
  ></i>
</span>
